/**
 * CollectSummary — Brief summary after all items collected
 *
 * Shows total count, total value, and dismiss button.
 * Auto-dismisses after 3 seconds.
 */

import { useEffect } from 'react';

interface CollectSummaryProps {
  title: string;
  totalItems: number;
  totalValue: number;
  onDismiss: () => void;
}

const AUTO_DISMISS_MS = 3000;

export function CollectSummary({
  title,
  totalItems,
  totalValue,
  onDismiss,
}: CollectSummaryProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div
      className="bg-gray-900 border border-gray-700 rounded-xl p-6 text-center max-w-sm mx-auto"
      style={{ animation: 'collectSummarySlideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards' }}
      onClick={(e) => e.stopPropagation()}
    >
      <h2 className="text-2xl font-bold text-yellow-400 mb-2">{title}</h2>
      <p className="text-gray-300 text-sm mb-1">
        Collected{' '}
        <span className="font-bold text-white">{totalItems}</span>{' '}
        creature{totalItems !== 1 ? 's' : ''}
      </p>
      <p className="text-yellow-300 text-lg font-bold mb-4">{totalValue}g</p>
      <button
        onClick={onDismiss}
        className="px-8 py-2.5 bg-yellow-500 hover:bg-yellow-600 text-black font-bold text-sm rounded-lg transition-colors min-h-[40px]"
      >
        Awesome!
      </button>
    </div>
  );
}
